import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalAccountDetailSalesAlertsDocument = gql`
  query SalesPortalAccountDetailSalesAlerts(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    analyticsAlerts: getAnalyticsAlerts(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      alert_statuses: [ACTIVE]
    ) {
      alerts_json
    }
  }
`;
export function useSalesPortalAccountDetailSalesAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailSalesAlertsQuery,
    Types.SalesPortalAccountDetailSalesAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalAccountDetailSalesAlertsQuery,
    Types.SalesPortalAccountDetailSalesAlertsQueryVariables
  >(SalesPortalAccountDetailSalesAlertsDocument, options);
}
export function useSalesPortalAccountDetailSalesAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalAccountDetailSalesAlertsQuery,
    Types.SalesPortalAccountDetailSalesAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalAccountDetailSalesAlertsQuery,
    Types.SalesPortalAccountDetailSalesAlertsQueryVariables
  >(SalesPortalAccountDetailSalesAlertsDocument, options);
}
export type SalesPortalAccountDetailSalesAlertsQueryHookResult = ReturnType<
  typeof useSalesPortalAccountDetailSalesAlertsQuery
>;
export type SalesPortalAccountDetailSalesAlertsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalAccountDetailSalesAlertsLazyQuery
>;
export type SalesPortalAccountDetailSalesAlertsQueryResult = Apollo.QueryResult<
  Types.SalesPortalAccountDetailSalesAlertsQuery,
  Types.SalesPortalAccountDetailSalesAlertsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailSalesAlertsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalAccountDetailSalesAlertsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailSalesAlertsQuery,
    Types.SalesPortalAccountDetailSalesAlertsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalAccountDetailSalesAlertsQuery,
    Types.SalesPortalAccountDetailSalesAlertsQueryVariables
  >(SalesPortalAccountDetailSalesAlertsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailSalesAlertsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalAccountDetailSalesAlertsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalAccountDetailSalesAlertsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalAccountDetailSalesAlertsQuery,
    Types.SalesPortalAccountDetailSalesAlertsQueryVariables
  >(SalesPortalAccountDetailSalesAlertsDocument, lazyOptions);
}
